import React from 'react';
import DataTableWithForm from '../components/DataTableWithForm';
import { API_BASE } from '../config';

const MachineCustomer = () => {
  const fetchUrl = '/zts/admin/v1.0/machine/customer/';
  const createUrl = '/zts/admin/v1.0/machine/customer/';
  const updateUrl = id => `/zts/admin/v1.0/machine/customer/${id}/`;
  const deleteUrl = id => `/zts/admin/v1.0/machine/customer/${id}/`;

  const columns = [
    { field: 'name', label: 'Name' },
    { field: 'is_active', label: 'Active' }
  ];

  const formFields = [
    { name: 'name', label: 'Name' },
    { name: 'is_active', label: 'Active' }
  ];

  return (
    <DataTableWithForm
      title="Machine Customer"
      fetchUrl={fetchUrl}
      createUrl={createUrl}
      updateUrl={updateUrl}
      deleteUrl={deleteUrl}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default MachineCustomer;

